import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClientFormPageComponent } from './components/client-form-page/client-form-page.component';
import { ClientViewPageComponent } from './components/client-view-page/client-view-page.component';
import { ClientsPageComponent } from './components/clients-page/clients-page.component';
import { ClientApiService } from './services/client-api/ClientApiService';
import { UserDirectoryApiService } from './services/user-api/UserDirectoryApiService';
import { TeamApiService } from '../events/services/team-api/TeamApiService';
import { OrderApiService } from '../orders/services/order-api/OrderApiService';

@NgModule({
  declarations: [
    ClientFormPageComponent,
    ClientViewPageComponent,
    ClientsPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  providers: [
    provideHttpClient(),
    ClientApiService,
    OrderApiService,
    TeamApiService,
    UserDirectoryApiService,
  ],
  exports: [
    ClientFormPageComponent,
    ClientViewPageComponent,
    ClientsPageComponent,
  ],
})
export class ClientsModule { }
